import { render } from "./SubmitPurchase.vue?vue&type=template&id=71a71a2e&ts=true"
import script from "./SubmitPurchase.vue?vue&type=script&lang=ts"
export * from "./SubmitPurchase.vue?vue&type=script&lang=ts"

import "./SubmitPurchase.vue?vue&type=style&index=0&id=71a71a2e&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__